import { ReactNode } from "react";

type TimerDurationButtonProps = {
  onClick: VoidFunction;
  children: ReactNode;
};

export default function TimerDurationButton({ onClick, children }: TimerDurationButtonProps) {
  return (
    <div
      onClick={onClick}
      sx={{
        padding: "dt_l",
        border: "dt_card",
        borderRadius: "dt_radius_s",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        position: "relative",
      }}
    >
      {children}
    </div>
  );
}
